import api from './api';

export const authService = {
  // Login admin user
  async login(email, password) {
    const response = await api.post('/auth/login', {
      email,
      password,
      platform: 'web' // Specify this is a web login
    });
    
    console.log('Login API response:', response); // Debug log
    
    // Handle the nested data structure
    return {
      user: response.data?.user || response.user,
      token: response.data?.token || response.token,
      refreshToken: response.data?.refreshToken || response.refreshToken
    };
  },

  // Logout user
  async logout() {
    try {
      await api.post('/auth/logout');
    } catch (error) {
      console.error('Logout API error:', error);
    }
  },

  // Refresh token
  async refreshToken() {
    const refreshToken = localStorage.getItem('refreshToken');
    if (!refreshToken) {
      throw new Error('No refresh token available');
    }
    
    const response = await api.post('/auth/refresh-token', { refreshToken });
    return response.data;
  },

  // Get current authenticated user profile
  async getProfile() {
    const response = await api.get('/auth/me');
    return response.data?.user || response.user;
  }
};